import { INPUT_CLASS, LABEL_CLASS, RespostasEtapa2Estado } from '../candidatoFormExternoEtapa2Page.definitions';
import CampoSimNao from './CampoSimNao';

interface EtapaPessoalProps {
  respostas: RespostasEtapa2Estado;
  onChange: <K extends keyof RespostasEtapa2Estado>(campo: K, valor: RespostasEtapa2Estado[K]) => void;
}

export default function EtapaPessoal({ respostas, onChange }: EtapaPessoalProps) {
  return (
    <>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Um pouco mais sobre você</h2>
      <div className="space-y-5">
        <div>
          <label className={LABEL_CLASS}>Com qual pronome pessoal você gostaria de ser chamado? *</label>
          <input
            type="text"
            className={INPUT_CLASS}
            value={respostas.pronome ?? ''}
            onChange={(e) => onChange('pronome', e.target.value)}
          />
        </div>
        <CampoSimNao
          label="Possui algum apelido?"
          valor={respostas.possuiApelido}
          onChange={(valor) => onChange('possuiApelido', valor)}
        />
        {respostas.possuiApelido && (
          <div>
            <label className={LABEL_CLASS}>Qual? *</label>
            <input
              type="text"
              className={INPUT_CLASS}
              value={respostas.apelido ?? ''}
              onChange={(e) => onChange('apelido', e.target.value)}
            />
          </div>
        )}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={LABEL_CLASS}>Tamanho de camisa *</label>
            <select
              className={INPUT_CLASS}
              value={respostas.tamanhoCamisa ?? ''}
              onChange={(e) => onChange('tamanhoCamisa', e.target.value)}
            >
              <option value="">Selecione</option>
              <option>P</option>
              <option>M</option>
              <option>G</option>
              <option>GG</option>
              <option>GGG</option>
              <option>GGGG</option>
              <option>Outro</option>
            </select>
          </div>
          <div>
            <label className={LABEL_CLASS}>Número de calçado *</label>
            <input
              type="text"
              inputMode="numeric"
              className={INPUT_CLASS}
              value={respostas.tamanhoCalcado ?? ''}
              onChange={(e) => onChange('tamanhoCalcado', e.target.value)}
            />
          </div>
        </div>
        <CampoSimNao
          label="Possui alguma alergia?"
          valor={respostas.possuiAlergia}
          onChange={(valor) => onChange('possuiAlergia', valor)}
        />
        {respostas.possuiAlergia && (
          <div>
            <label className={LABEL_CLASS}>Qual? *</label>
            <input
              type="text"
              className={INPUT_CLASS}
              value={respostas.alergiaDescricao ?? ''}
              onChange={(e) => onChange('alergiaDescricao', e.target.value)}
            />
          </div>
        )}
        <div>
          <label className={LABEL_CLASS}>Qual seu tipo de alimentação? *</label>
          <select
            className={INPUT_CLASS}
            value={respostas.tipoAlimentacao ?? ''}
            onChange={(e) => onChange('tipoAlimentacao', e.target.value)}
          >
            <option value="">Selecione</option>
            <option>Onívoro</option>
            <option>Vegetariano</option>
            <option>Vegano</option>
            <option>Outro</option>
          </select>
        </div>
        <CampoSimNao
          label="Possui alguma restrição alimentar?"
          valor={respostas.possuiRestricaoAlimentar}
          onChange={(valor) => onChange('possuiRestricaoAlimentar', valor)}
        />
        {respostas.possuiRestricaoAlimentar && (
          <div>
            <label className={LABEL_CLASS}>Qual? *</label>
            <input
              type="text"
              className={INPUT_CLASS}
              value={respostas.restricaoAlimentarDescricao ?? ''}
              onChange={(e) => onChange('restricaoAlimentarDescricao', e.target.value)}
            />
          </div>
        )}
        <CampoSimNao
          label="Possui animal de estimação?"
          valor={respostas.possuiPet}
          onChange={(valor) => onChange('possuiPet', valor)}
        />
        {respostas.possuiPet && (
          <div>
            <label className={LABEL_CLASS}>Qual e o nome dele? *</label>
            <input
              type="text"
              className={INPUT_CLASS}
              value={respostas.petDescricao ?? ''}
              onChange={(e) => onChange('petDescricao', e.target.value)}
            />
          </div>
        )}
      </div>
    </>
  );
}
